import checkout from "./form";

const {
  formField: {
    taxCalculationPeriod,
    firstTime,
    supplementaryForThe,
    taxpayerName,
    taxId1,
    checkbox1,
    certificate,
    fullName,
    signer,
    timeSign,
    organizationName,
    address,
    district,
    province,
    taxAgencyId,
    taxAgencyName,
    taxId2,
    phone,
    email,
    fax,
  },
} = checkout;

const initialValues = {
  [email.name]: "",
  [phone.name]: "",
  [fax.name]: "",
  [firstTime.name]: false,
  [supplementaryForThe.name]: "",
  [organizationName.name]: "",
  [district.name]: "",
  [province.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxId2.name]: "",
  [taxCalculationPeriod.name]: "",
  [address.name]: "",
  [taxId1.name]: "",
  [taxpayerName.name]: "",
  [certificate.name]: "",
  [signer.name]: "",
  [fullName.name]: "",
  [timeSign.name]: "",
  [checkbox1.name]: false,
};

export default initialValues;
